<template>
  <NewBsBox
    :bs="{
      'cmp.switch': 'wrapper',
      ...bs,
    }"
    as="label"
  >
    <NewBsBox
      :bs="{ 'cmp.switch': 'switchInput' }"
      :data-is-checked="modelValue"
      :checked="modelValue"
      :disabled="disabled || readonly"
      :context="{ size }"
      as="input"
      type="checkbox"
      @change="onInput"
    />
    <NewBsBox
      :bs="{
        'cmp.switch': 'control',
        'cmp.switch.controlSize': size,
        ...controlBs,
        justifyContent: modelValue ? 'flex-start' : 'flex-end',
      }"
    >
      <NewBsBox
        :bs="{
          'cmp.switch': 'controlChecked',
          'cmp.switch.controlCheckedSize': size
        }"
      />
      <slot
        v-if="modelValue"
        name="checked"
      />
      <slot
        v-else
        name="unChecked"
      />
    </NewBsBox>
    <slot>
      <NewBsBox
        :bs="{ 'cmp.switch': 'label' }"
      >
        <!-- @slot 自定义标签 -->
        {{ label }}
      </NewBsBox>
    </slot>
  </NewBsBox>
</template>

<script lang="ts">
  import { PropType, defineComponent } from 'vue'
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import { BeerStyleObj } from '../../../core'
  import initStyle from './style'

  initStyle()

  export default defineComponent({
    name: 'BeerSwitch',
    components: {
      NewBsBox,
    },
    props: {
      /**
       * 开关的标签
       * 使用 FormGroup 的时候，建议用它的label，这个置空
       */
      label: {
        type: String,
        required: false,
      },
      /**
       * 是否开启状态
       * @type {true|false}
       */
      modelValue: {
        type: Boolean,
        default: false,
      },
      /**
       * 是否禁用
       * @type {true|false}
       */
      disabled: {
        type: Boolean,
        default: false,
      },
      /**
       * 是否只读
       */
      readonly: {
        type: Boolean,
        default: false,
      },
      /**
       * - 'm' as medium
       * - 's' as small
       * @type {s|m}
       */
      size: {
        type: String,
        default: 'm',
      },
      /**
       * @ignore
       *  wrapper bs to override default
       */
      bs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
      /**
       * @ignore
       *  wrapper bs to override default
       */
      controlBs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
      /**
       * 可以用 v-model 双向绑定
       * modelValue
       * update:modelValue
       */
      const onInput = () => {
        if (props.disabled || props.readonly) {
          return
        }
        emit('update:modelValue', !props.modelValue)
      }

      return {
        onInput,
      }
    },
  })
</script>
